var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Nav } from 'react-bootstrap';
import { RxCross1 } from "react-icons/rx";
import { FaCheck } from "react-icons/fa6";
const getClassName = (variant, validation = 'none') => {
    let className = `nav-item ${variant}`;
    if (validation === 'validationSuccess') {
        className += ' validation-success';
    }
    else if (validation === 'validationFailed') {
        className += ' validation-failed';
    }
    return className;
};
export const TabGroupNav = (_a) => {
    var { eventKey, label, variant, validation } = _a, props = __rest(_a, ["eventKey", "label", "variant", "validation"]);
    const className = useMemo(() => getClassName(variant, validation), [variant, validation]);
    return (_jsx(Nav.Item, { children: _jsxs(Nav.Link, Object.assign({ eventKey: eventKey }, props, { className: `${className} ${props.active ? 'active' : 'inactive'}` }, { children: [validation === 'validationSuccess' && _jsx(FaCheck, {}), validation === 'validationFailed' && _jsx(RxCross1, {}), label] })) }));
};
